/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, EventEmitter, Input, Output, Inject, SimpleChange, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { Iceutility } from '../../services/iceutility';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcecontrolSettings, iceColumnDefinition, IcecontrolPermission } from '../../components/models/icesettings';
import { IcematgridComponent } from '../icepanel/icematgrid.component';
import { userTypes } from '../../login/login.config';
import { IceTypes } from '../../models/icetypes';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'icedatepicker',
    templateUrl: './icedatepicker.component.html',
    styleUrls: ['./icedatepicker.component.scss']
})
export class IcedatepickerComponent implements OnInit {
  @Input() datePickerSettings: IcecontrolSettings = null;
  @Input() placeholder: string;
  @Input() dateChange: any;
  @Input() properties: any;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;

  @Output() DateChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent,
    private dateAdapter: DateAdapter<Date>, private loginSvc: LoginService) {
    // For now, we only need to set the locale for the date control
    Iceutility.setLocal(dateAdapter, this.loginSvc.currentDateFormat);
  }

  ngOnInit() {
    try {
      this.permission = this.datePickerSettings.permissions ? this.datePickerSettings.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);

      if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else {
        this.iceFormControl = this.datePickerSettings.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }

      if (Iceutility.isdefined(this.datePickerSettings.properties["dateFormat"]) && this.datePickerSettings.properties["dateFormat"] !== "") {
        this.setDateFormat(this.datePickerSettings.properties["dateFormat"]);
      }

      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.iceFormControl.disable();
      }

      this.iceFormControl.valueChanges.subscribe(val => {
        if (val === "date change") {
          this.setDateFormat(this.datePickerSettings.properties["dateFormat"]);
        }
      });
    }
    catch (e) {
      console.log(e);
    }

    if (Iceutility.isdefined(this.datePickerSettings.properties)) {
        if (Iceutility.isdefined(this.datePickerSettings.properties.placeholder)) {
            this.placeholder = this.datePickerSettings.properties.placeholder;
        }
    }
  }

  getTimeValue(): string {
    let tval = "";
    if (Iceutility.isdefined(this.datePickerSettings.properties)) {
      if (Iceutility.isdefined(this.datePickerSettings.properties.timevalue)) {
        tval = this.datePickerSettings.properties.timevalue;
      }
    }

    return tval;
  }

  isReadonly(): boolean {
    if (this.datePickerSettings == null) return false;

    return this.datePickerSettings.getReadonly();
  }

  isDisabled(): boolean {
    if (this.datePickerSettings == null || this.permission == null) return false;

    if (this.datePickerSettings.getDisabled()) return true;

    return this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
  }

  public getStyle(): any {
    let style = {
      "width": "100px",
    };

    if (this.datePickerSettings == null || this.datePickerSettings.properties == null) return style;

    if (this.datePickerSettings.properties.width != null) {
      style.width = this.datePickerSettings.properties.width;
    }
    return style;
  }

  onDateChange(event) {
    event.datePickerSettings = this.datePickerSettings;
    if (this.matTableObject && this.matTableObject.controlChange) {
      if (this.tableRowData != null && this.tableColumn != null) {
        this.tableRowData[this.tableColumn.columnName] = Iceutility.getDateTextEx(event.value);
        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;
      }

      this.matTableObject.onControlChange(event);
    }
    else if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);
  }

  setDateFormat(dateFormat: string = this.loginSvc.currentDateFormat) {
    Iceutility.setLocal(this.dateAdapter, dateFormat, true);
  }
}
